// eslint-disable-next-line import/prefer-default-export
export const TestProcesses = [
  {
    id: "1",
    name: "Platinum Credit Card",
    desc: "Top of the range Credit Card",
    casesToReview: 7,
    casesOverridden: 21,
  },
  {
    id: "2",
    name: "Entry Level Credit Card",
    desc: "Student Friendly Credit Card",
    casesToReview: 4,
    casesOverridden: 65,
  },
  {
    id: "3",
    name: "1.49% Fixed 60% LTV 2 year Mortgage 2021",
    desc: "2 Year Fixed Fee saver",
    casesToReview: 2,
    casesOverridden: 11,
  },
];
